import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { polyglot } from '../../../index'
import AgeGrid from './AgeGrid/AgeGrid'
import Range from './Range/Range'
import Loading from '../../common/Loading/Loading'
import Development from './Development/Development'

export default class Consultations extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      renderRange: !!props.match.params.rangeId,
      currentRange: undefined
    }
  }

  componentWillReceiveProps (props) {
    if (props.match.params.rangeId) {
      this.setState({
        renderRange: !!props.match.params.rangeId
      })
    } else {
      if (this.props.patient) {
        this.setState({renderRange: !!props.match.params.rangeId})
        this.redirectToRange(props.match.url)
      }
    }
  }

  redirectToRange (currentUrl) {
    let isRedirected
    const patientBirthDate = this.props.patient.birthDate
    const today = moment()
    const currentAge = moment(this.props.patient.birthDate).add(moment.duration(today.diff(patientBirthDate)))
    this.props.configuration.ageRange.forEach(range => {
      const rangeStart = moment(patientBirthDate).add(moment.duration(range.start))
      const rangeEnd = moment(patientBirthDate).add(moment.duration(range.finish))
      if (currentAge.isBetween(rangeStart, rangeEnd, null, '[)')) {
        this.props.history.replace({pathname: `${currentUrl}/${range.id}`})
        isRedirected = true
      }
    })
    if (!isRedirected) {
      const lastRange = this.props.configuration.ageRange[this.props.configuration.ageRange.length - 1]
      this.props.history.replace({pathname: `${currentUrl}/${lastRange.id}`})
    }
  }

  componentWillMount () {
    this.props.hidePatientIndicator(false)
    if (this.props.auth.isAuthenticated()) {
      if (this.props.match.params.patientId) {
        if (!this.props.patientKey) {
          this.props.patientChangeHandle(this.props.match.params.patientId)
        }
      } else {
        this.props.history.replace('/patients')
      }
    }
    if (this.props.patient) {
      this.redirectToRange(this.props.match.url)
    }
  }

  getAgesForGrid () {
    const ages = []
    this.props.configuration['ageRange'].forEach(element => {
      ages.push({text: polyglot.t(`ageRange.${element.name}`), url: (element.id).toString()})
    })
    return ages
  }

  render () {
    if (this.props.patient && this.state.renderRange) {
      window.myLogger.info(JSON.stringify({message: 'Consultations Component Rendered', patient: this.props.patientKey}))
      return <div className='container-fluid'>
        <div className='col-xs-12 col-md-7'>
          <AgeGrid ages={this.getAgesForGrid()} selectedAge={this.props.match.params.rangeId} patientId={this.props.match.params.patientId} />
        </div>
        <div className='col-xs-12 col-md-5 pull-right'>
          <Development
            developmentsData={this.props.configuration['developments']}
            insertionConfiguration={this.props.configuration['developmentInsertion']}
            patientKey={this.props.patientKey}
            patient={this.props.patient} />
        </div>
        <div className='col-xs-12 col-md-7 no-side-padding'>
          <Range
            patientKey={this.props.patientKey}
            patient={this.props.patient}
            configuration={this.props.configuration}
            rangeId={this.props.match.params.rangeId} />
        </div>
      </div>
    } else {
      return <Loading />
    }
  }
}

Consultations.propTypes = {
  patient: PropTypes.object,
  patientKey: PropTypes.string,
  auth: PropTypes.object.isRequired,
  patientChangeHandle: PropTypes.func.isRequired,
  hidePatientIndicator: PropTypes.func.isRequired,
  configuration: PropTypes.object.isRequired
}



// WEBPACK FOOTER //
// ./src/components/general/Consultations/Consultations.js